import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getExchangeUrl = (cId) => `/companies/${cId}/exchanges`;
const getExchangeByIdUrl = (iId, cId) => `/companies/${cId}/exchanges/${iId}`;
const addExchangeUrl = (cId) => `/companies/${cId}/exchanges`;
const updateExchangeUrl = (iId, cId) => `/companies/${cId}/exchanges/${iId}`;
const getFormConfigUrl = (cId) => `/companies/${cId}/exchanges/form_config`;

const service = {
  configure(endpoint, auth, defaultHeaders) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, filters, limit, page, orderBy, order) {
    const url = getExchangeUrl(companyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(exchangeId, companyId) {
    const url = getExchangeByIdUrl(exchangeId, companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, exchange) {
    const url = addExchangeUrl(companyId);
    return this.axios
      .post(url, exchange, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(exchangeId, companyId, exchange) {
    const url = updateExchangeUrl(exchangeId, companyId);
    return this.axios
      .put(url, exchange, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  formConfig(companyId) {
    const url = getFormConfigUrl(companyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/exchange.api.js